import { Inject, Injectable, InjectionToken } from '@angular/core';

import moment from 'moment-timezone';

export const APP_ENV = new InjectionToken('App Env');

@Injectable()
export class SubscriptionBannerHelpers {
  public MonthlyLegacyMigrationDates: Record<
    'lastBillingCycleStartDate' | 'dueDate',
    moment.Moment
  > = {
    lastBillingCycleStartDate:
      this.env === 'production' ? moment('2022-05-01') : moment('2022-02-28'),
    dueDate: this.env === 'production' ? moment('2022-06-15') : moment('2022-03-15'),
  };

  public isLastBillingCycleForMonthlyLegacy = moment().isSameOrAfter(
    this.MonthlyLegacyMigrationDates['lastBillingCycleStartDate'],
  );

  constructor(@Inject(APP_ENV) private env: string) {}

  public diffDates = (
    date: string | moment.Moment,
    unitOfTime: 'days' | 'months' = 'days',
  ): number =>
    Math.round(
      (moment.isMoment(date) ? date : moment(date).endOf(unitOfTime)).diff(
        moment(),
        unitOfTime,
        unitOfTime === 'months',
      ),
    );
}
